import React from "react";
import { Table } from "reactstrap";
import { addClassName } from "../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../Utils/calculate-progress.js";
import RenderModals from "../../Modals/modal";
import EditModal from "./Invitation-Modal/Edit-Modal/EditModal";
import DeleteModal from "./Invitation-Modal/Delete-Modal/DeleteModal";
import editIcon from "../../../../images/new-images/edit-green.svg";
import editdisable from "../../../../images/new-images/edit-disable.svg";
import reminderIcon from "../../../../images/new-images/reminder-blue.svg";
import completed from "../../../../images/new-images/completed.png";
import reminderDisableIcon from "../../../../images/new-images/reminder-disable.svg";
import RenderinviteRespondantsModal from "./Invitation-Modal/Invite-respondants-modal";
import "./Sent.css";
import MyinvitationsEmpty from "../Invitations-Empty";

const Sent = (props) => {



  const editButtonControll = (
    respondentRelationship,
    groupId,
    uid,
    rid,
    respondentEmail,
    is_submited,
    respondantStatus
  ) => {
    if (is_submited === true || respondantStatus === "In progress") {
      return <img style={{ cursor: "not-allowed" }} src={editdisable} />;
    } else {
      return (
        <div>


          <img
            onClick={() =>
              props.handleEditModal(
                respondentEmail,
                respondentRelationship,
                uid,
                rid,
                groupId
              )
            }
            src={editIcon}
          />
          <RenderModals
            assessmentModal={props.editModal}
            handleModalClose={props.handleModalClose}
            modalHeading="EDIT RELATIONSHIP"
          >
            <EditModal
              handleUnfilteredEditModalSubmit={
                props.handleUnfilteredEditModalSubmit
              }
              respondentEmail={props.respondentEmail}
              respondentRelationship={props.respondentRelationship}
              dropDownOptions={props.dropDownOptions}
              assessmentUserId={props.assessmentUserId}
              accessorGroupId={props.accessorGroupId}
              relationShipId={props.relationShipId}
              handleModalClose={props.handleModalClose}
              filteredSentRespondants={props.filteredSentRespondants}
              handleDropdownOptions={props.handleDropdownOptions}
              sentRespondantsId={props.sentRespondantsId}
              sentRespondantsFilteredId={props.sentRespondantsFilteredId}
              handleEditModalSubmit={props.handleEditModalSubmit}
            />
          </RenderModals>
        </div>
      );
    }
  };

  const reminderButtonControll = (
    getStatus,
    userId,
    respondantsId,
    respondantEmail
  ) => {
    if (getStatus === "Completed" || getStatus === "In progress") {
      return (
        <img style={{ cursor: "not-allowed" }} src={reminderDisableIcon} />
      );
    } else {
      return (
        <img
          src={reminderIcon}
          onClick={() =>
            props.handleReminder(userId, respondantsId, respondantEmail)
          }
        />
      );
    }
  };

  return (
    <div className="sent-Tab">
    

      <RenderModals
        assessmentModal={props.respondentInvitationsModal}
        handleModalClose={props.handleModalClose}
        modalHeading="INVITE RESPONDENT"
      >
        <RenderinviteRespondantsModal
          inputFields={props.inputFields}
          handleInputFields={props.handleInputFields}
          dropDownOptions={props.dropDownOptions}
          isChecked={props.isChecked}
          isDisabled={props.isDisabled}
          handleModalFormSubmit={props.handleModalFormSubmit}
          handleModalClose={props.handleModalClose}
        />
      </RenderModals>
      <div
        style={
          props.sentRespondants.length == 1 ||
            props.sentRespondants.length == 2 ||
            props.sentRespondants.length == 3
            ? { height: "auto" }
            : { height: "410px", overflowY: "auto" }
        }
        className="custom-height"
      >
        {props.sentRespondants.length == 0 ||
          props.getRespondantStatus.length == 0 ? (
          <MyinvitationsEmpty emptyText="You do not have any respondants yet." />
        ) : (
          <Table>
            <thead>
              <tr>
                <th className="tableHeaders">Respondents</th>
                <th className="tableHeaders">Relationship</th>
                <th className="tableHeaders">Assessment Expiry Date</th>
                <th className="tableHeaders">Status</th>
                <th className="tableHeaders">Manage Actions</th>
                <th className="tableHeaders">Send Reminder</th>
              </tr>
            </thead>
            <tbody>
              <React.Fragment>
                {props.sentRespondants.map((details, index) => {
                  return (
                    <React.Fragment key={index}>
                      {details.respondents.map((respondentData, index) => (
                        <tr key={index}>
                          <td>{respondentData.respondent__email}</td>
                          <td>
                            {respondentData.assessor_group__assessor_name}
                          </td>
                          <td>{respondentData.user_assessment__expiry_date}</td>
                          <td>
                            {respondentData.assessment_status__status_name ===
                              "In progress" ? (
                              <div
                                style={{ display: "flex", gap: "5px" }}
                                className={
                                  "assessment-status-text " +
                                  addClassName(
                                    respondentData.assessment_status__status_name
                                  )
                                }
                              >
                                {respondentData.assessment_status__status_name}
                                {calcPercentage(
                                  respondentData.user_assessment__assessment_number_count,
                                  respondentData.respondent_completed_count
                                )}
                              </div>
                            ) : respondentData.assessment_status__status_name ===
                              "Completed" ? (
                              <div
                                className={
                                  "assessment-status-text " +
                                  addClassName(
                                    respondentData.assessment_status__status_name
                                  )
                                }
                              >
                                {respondentData.assessment_status__status_name}
                                <img src={completed} alt="Completed Image" />
                              </div>
                            ) : (
                              <div
                                className={
                                  "assessment-status-text " +
                                  addClassName(
                                    respondentData.assessment_status__status_name
                                  )
                                }
                              >
                                {respondentData.assessment_status__status_name}
                              </div>
                            )}
                          </td>
                          <td>
                            <div className="actions">
                              <div className="edit-Icon">
                                {editButtonControll(
                                  respondentData.assessor_group__assessor_name,
                                  respondentData.assessor_group__id,
                                  respondentData.user_assessment__id,
                                  respondentData.id,
                                  respondentData.respondent__email,
                                  respondentData.is_submited,
                                  respondentData.assessment_status__status_name
                                )}
                              </div>
                             
                              <RenderModals
                                assessmentModal={props.deleteModal}
                                handleModalClose={props.handleModalClose}
                                modalHeading="DELETE RESPONDENT"
                              >
                                <DeleteModal
                                  handleModalClose={props.handleModalClose}
                                  handleDeleteRequest={
                                    props.handleDeleteRequest
                                  }
                                  respondentEmail={props.respondentEmail}
                                  respondantUserAssessmentId={
                                    props.respondantUserAssessmentId
                                  }
                                  respondantIndividualId={
                                    props.respondantIndividualId
                                  }
                                />
                              </RenderModals>
                            </div>
                          </td>
                          <td>
                            <div className="Line"></div>
                            <div className="reminder-Icon">
                              {reminderButtonControll(
                                respondentData.assessment_status__status_name,
                                respondentData.user_assessment__id,
                                respondentData.respondent__email,
                                respondentData.respondent__id
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  );
                })}
              </React.Fragment>
            </tbody>
          </Table>
        )}
      </div>
    </div>
  );
};

export default Sent;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Sent/Sent.jsx